export default __webpack_public_path__ + "static/media/ballons.92c42c8e.svg";